export const TRACKING_COMPONENTS = {
  HOME_PAGE: {
    PENDING_POS: "PENDING_POS",
    PENDING_GRNS: "PENDING_GRNS",
    ALL_POS: "ALL_POS",
    ALL_DD_POS: "ALL_DD_POS",
    PENDING_INVOICES: "PENDING_INVOICES",
    REJECTED_INVOICES: "REJECTED_INVOICES",
    LOGOUT_MODAL_TOGGLE: "LOGOUT_MODAL_TOGGLE",
    LOGOUT_CONFIRM: "LOGOUT_CONFIRM",
    DD_PO_DETAILS_POD: "DD_PO_DETAILS_POD",
    CONFIRM_GRN_CTA: "CONFIRM_GRN_CTA",
  },
  COMMON: {
    PAGE: "PAGE",
    BUTTON: "BUTTON",
  }
};

export const TRACKING_PAGES = {
  HOME: "HOME_PAGE",
};
